export default {
  loginOrRegister: {
    registration: 'Registro (30 seg)',
    Login: 'Login',
    authentication: 'Autenticação'
  }
}
